module.exports = __webpack_public_path__ + "media/images/application/icons/icon-shield-6e6e2e81bf89c542ea583f809daca359.svg";